import { render, staticRenderFns } from "./NewSurveyNotification.vue?vue&type=template&id=25e8ff24&scoped=true"
import script from "./NewSurveyNotification.vue?vue&type=script&lang=js"
export * from "./NewSurveyNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e8ff24",
  null
  
)

export default component.exports